// Description: Navigation functionality.
//
// Refactored to use ES6 syntax and functions.

/**
 * Global navigation variables.
 */
let isSubMenuClickEventListenerAdded = false;
let isSubMenuOutsideClickEventListenerAdded = false;

// Region: Sub Menus

/**
 * Sets up the submenu functionality.
*/
const setupSubMenus = () => {
    const targets = document.querySelectorAll(".js-main-menu-sub-menu-toggle");
    if (!isSubMenuClickEventListenerAdded) {
        targets.forEach(target => {
            target.addEventListener("click", (e) => {
                subMenuToggle(target);
            });
        });
        isSubMenuClickEventListenerAdded = true;
    }

    if (!isSubMenuOutsideClickEventListenerAdded) {
        document.body.addEventListener('click', handleOutsideSubMenuClick);
        isSubMenuOutsideClickEventListenerAdded = true;
    }
};

/**
 * Handles the outside submenu click event.
 * @param {Event} event - The event object.
 */
const handleOutsideSubMenuClick = (event) => {
    const clickedElement = event.target;
    const divOuterMainContent = document.querySelector('.o-main-content');
    if (!doesClassExist('o-main-content')) { return false; }
    const isSideNavClosed = divOuterMainContent.classList.contains('o-main-content--side-nav-closed');
    const parentMenuItem = clickedElement.closest('.main-menu__item');

    if (!parentMenuItem && isSideNavClosed) {
        const openSubMenus = document.querySelectorAll('.main-menu__item.open');
        openSubMenus.forEach(menuItem => {
            menuItem.classList.remove('open');
            const subMenu = menuItem.querySelector('.main-menu__sub-menu');
            subMenu.style.display = 'none';
        });
    }

};

/**
 * Toggles the submenu based on the menu section clicked.
 * @param {HTMLElement} menuSection - The menu section clicked.
 */
const subMenuToggle = (menuSection) => {
    const parent = menuSection.parentElement;
    const isOpen = parent.classList.contains("open");
    const divOuterMainContent = document.querySelector(".o-main-content");
    const isSideNavClosed = divOuterMainContent.classList.contains("o-main-content--side-nav-closed");
    const subMenu = parent.querySelector(".main-menu__sub-menu");
    const isSubMenuOpen = subMenu.style.display === "block";
    const siblings = parent.parentElement.querySelectorAll(".open");

    siblings.forEach(sibling => {
        if (sibling !== parent) {
            sibling.classList.remove("open");
            sibling.querySelector(".main-menu__sub-menu").style.display = "none";
        }
    });

    if (isOpen) {
        if (isSideNavClosed && !isSubMenuOpen) {
            subMenu.style.display = "block";
        } else {
            parent.classList.remove("open");
            subMenu.style.display = "none";
        }
    } else {
        parent.classList.toggle("open");
        const displayStyle = isOpen ? "none" : "block";
        subMenu.style.display = displayStyle;
    }
};

//End Region: Sub Menus
//Region: Side Nav
/**
 * Toggles the side navigation.
 */
const toggleSideNav = () => {
    const divOuterMainContent = document.querySelector(".o-main-content");
    if (divOuterMainContent.classList.contains("o-main-content--side-nav-closed")) {
        expandSideNav();
    } else {
        collapseSideNav();
    }
};

/**
 * Collapses the side navigation.
 */
const collapseSideNav = () => {
    callHandler('/Endpoints/UpdateSidebarPreference.ashx', '?fdExpandSidenav=0', false);

    const sideNavMenu = document.querySelector('.side-nav__menu');
    sideNavMenu.style.opacity = '0';

    const mainMenu = document.querySelector('.js-main-menu');
    mainMenu.classList.add('side-nav-transition', 'collapsed');
    mainMenu.style.opacity = '0';

    const mainMenuItems = document.querySelectorAll('.main-menu__item.open');
    mainMenuItems.forEach(item => {
        item.classList.remove('open');
        const subMenu = item.querySelector('.main-menu__sub-menu');
        subMenu.style.display = 'none';
    });

    const mainContent = document.querySelector('.main-content');
    mainContent.classList.add('side-nav-transition', 'collapsed');
    mainContent.style.marginLeft = '100px';

    const siteHeaderOuter = document.querySelector('.c-site-header__outer');
    siteHeaderOuter.classList.add('side-nav-transition', 'collapsed');
    siteHeaderOuter.style.paddingLeft = '100px';

    const mainRadiusBlock = document.querySelector('.js-main-radius-block');
    mainRadiusBlock.classList.add('side-nav-transition', 'collapsed');
    mainRadiusBlock.style.left = '100px';

    const sideNav = document.querySelector('.side-nav');
    sideNav.classList.add('side-nav-transition', 'collapsed');
    sideNav.style.width = '100px';

    const outerMainContent = document.querySelector('.o-main-content');
    outerMainContent.classList.add('o-main-content--side-nav-closed');

    setTimeout(() => {
        mainMenu.style.opacity = '1';
        sideNavMenu.style.opacity = '1';
    }, 200);
};

/**
 * Expands the side navigation.
 */
const expandSideNav = () => {
    callHandler('/Endpoints/UpdateSidebarPreference.ashx', '?fdExpandSidenav=1', false);

    const sideNavMenu = document.querySelector('.side-nav__menu');
    sideNavMenu.style.opacity = '0';

    const mainMenu = document.querySelector('.js-main-menu');
    mainMenu.classList.remove('collapsed');
    mainMenu.style.opacity = '0';

    const outerMainContent = document.querySelector('.o-main-content');
    outerMainContent.classList.remove('o-main-content--side-nav-closed');

    const mainContent = document.querySelector('.main-content');
    mainContent.classList.remove('collapsed');
    mainContent.style.marginLeft = '280px';

    const siteHeaderOuter = document.querySelector('.c-site-header__outer');
    siteHeaderOuter.classList.remove('collapsed');
    siteHeaderOuter.style.paddingLeft = '280px';

    const mainRadiusBlock = document.querySelector('.js-main-radius-block');
    mainRadiusBlock.classList.remove('collapsed');
    mainRadiusBlock.style.left = '280px';

    const sideNav = document.querySelector('.side-nav');
    sideNav.classList.remove('collapsed');
    sideNav.style.width = '280px';

    setTimeout(() => {
        mainMenu.style.opacity = '1';
        sideNavMenu.style.opacity = '1';
    }, 200);
};
//End Region: Side Nav